import React from 'react';

type GlobeProps = {
  width?: string;
  height?: string;
  fill?: string;
  stroke?: string;
  strokeWidth?: string;
  circleStroke?: string;
  circleFill?: string;
  radius?: string;
  style?: React.CSSProperties;
};

function Globe({
  width = '18',
  height = '18',
  fill = 'none',
  stroke = 'black',
  strokeWidth = '2',
  circleStroke = 'black',
  circleFill = 'white',
  radius = '20px',
  style,
}: GlobeProps) {
  return (
    <svg
      width={width}
      height={height}
      style={style}
      fill={fill}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g transform='translate(3, 2)'>
        <path
          d='M9 2C10.876 4.05376 11.9421 6.71903 12 9.5C11.9421 12.281 10.876 14.9462 9 17M9 2C7.12404 4.05376 6.05794 6.71903 6 9.5C6.05794 12.281 7.12404 14.9462 9 17M9 2C4.85786 2 1.5 5.35786 1.5 9.5C1.5 13.6421 4.85786 17 9 17M9 2C13.1421 2 16.5 5.35786 16.5 9.5C16.5 13.6421 13.1421 17 9 17M1.87501 7.25H16.125M1.875 11.75H16.125'
          stroke={stroke}
          stroke-width={strokeWidth}
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
    </svg>
  );
}

export default Globe;
